import { render } from "./ProductDetailsReportModal.vue?vue&type=template&id=fa08fede"
import script from "./ProductDetailsReportModal.vue?vue&type=script&lang=js"
export * from "./ProductDetailsReportModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__